/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SlideClassificationSubtype = {
    readonly id?: number;
    diagnosis: string;
    diagnosis_result: SlideClassificationSubtype.diagnosis_result;
    /**
     *
     * Has one or more fixed value for a given diagnosis, for example:
     * - With BCC: "Infiltrative" is always equal "SubtypeSeverity.SEVERE" and
     *
     */
    severity?: SlideClassificationSubtype.severity | null;
    readonly roi_positions?: Array<any>;
    microscopic_description: string;
    /**
     * Expressed in millimeters
     */
    deep_margin?: number | null;
    /**
     * Expressed in millimeters
     */
    depth?: number | null;
    /**
     * Expressed in millimeters
     */
    left_margin?: number | null;
    /**
     * Expressed in millimeters
     */
    right_margin?: number | null;
}

export namespace SlideClassificationSubtype {

    export enum diagnosis_result {
        POSITIVE = 'POSITIVE',
        NEGATIVE = 'NEGATIVE',
        INCONCLUSIVE = 'INCONCLUSIVE',
    }

    /**
     *
     * Has one or more fixed value for a given diagnosis, for example:
     * - With BCC: "Infiltrative" is always equal "SubtypeSeverity.SEVERE" and
     *
     */
    export enum severity {
        '_5' = 5,
        '_4' = 4,
        '_3' = 3,
        '_2' = 2,
        '_1' = 1,
        '_0' = 0,
    }


}
